export default __webpack_public_path__ + "static/media/i11.9694b96b.svg";